<template>
  <v-container fluid fill-height>
    <v-layout justify-center align-top v-if="init">

      <v-flex text-xs-center v-if="errorMessage === 'unknown'">
        <p style="padding-left: 15px">Произошла неизвестная ошибка, обратитесь к администратору</p>
      </v-flex>

      <v-flex text-xs-center v-if="errorMessage === ''">
        <v-form>
          <v-layout row wrap align-center justify-center fill-height>

            <v-flex xs12>
              <h1>Мой аккаунт</h1>
            </v-flex>

            <v-flex xs12 sm10 md8 lg7>
              <v-select
                v-model="selectedCompany"
                :items="accountInfo.salons"
                item-text="name"
                item-value="id"
                label="Основная компания"
                required>
                <template slot='selection' slot-scope='{ item }'>
                  {{ item.yId }} - {{ item.yPublicTitle }}
                </template>
                <template slot='item' slot-scope='{ item }'>
                  {{ item.yId }} - {{ item.yPublicTitle }}
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 sm10 md8 lg7 class="padding5">
              <v-layout row>
                <v-flex xs2 class="padding5">
                  <v-select
                    v-model="phoneCode"
                    :items="items"
                    label="Код страны"
                  ></v-select>
                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex xs9 class="padding5">
                  <v-text-field
                    v-model="accountInfo.user.mobile"
                    label="Мобильный телефон"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm10 md8 lg7 class="padding5">
              <v-text-field
                v-model="accountInfo.user.email"
                label="Email"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 text-xs-center>
              <v-btn color="#4169E1" style="color:white" @click="updateAccount()">Сохранить</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
        <br>
        <v-form ref="password">
          <v-layout row wrap align-center justify-center fill-height>
            <v-flex xs12>
              <h1>Смена пароля</h1>
            </v-flex>
            <v-flex xs12 sm10 md8 lg7 class="padding5">
              <v-text-field required :rules="passwordRules" v-model="password" name="password" label="Пароль" id="password" type="password"></v-text-field>
            </v-flex>
            <v-flex xs12 sm10 md8 lg7 class="padding5">
              <v-text-field required :rules="rules" v-model="password2" name="password2" label="Подтвердите пароль" type="password"></v-text-field>
            </v-flex>
            <v-flex xs12 text-xs-center>
              <v-btn color="#4169E1" style="color:white" @click="changePassword()">Сменить пароль</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
        <!-- <br>
        <v-form>
          <v-layout row wrap align-center justify-center fill-height>
            <v-flex xs12>
              <h1>Facebook аккаунт</h1>
            </v-flex>

            <v-flex xs12 sm10 md8 lg7 class="padding5" v-if="!hasFBAccount">
              <v-btn @click="connectFB" color="#4267b2" style="color:white"><v-icon style="padding-right: 10px;">mdi-facebook</v-icon>привязать</v-btn>
            </v-flex>
            <v-flex xs12 sm10 md8 lg7 class="padding5" v-if="hasFBAccount">
              <v-chip v-model="chip" color="#4267b2" close style="color: white">
                <v-avatar>
                  <v-icon>check_circle</v-icon>
                </v-avatar>
                {{account.facebookName}}
              </v-chip>
            </v-flex>
          </v-layout>
        </v-form> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    phoneCode: '',
    items: ['+375', '+7'],
    // chip: true,
    // mask: '(##) ###-##-##',
    // hasFBAccount: false,
    accountInfo: {},
    selectedCompany: '',
    errorMessage: '',
    password: '',
    passwordRules: [
      v => !!v || 'Необходимо заполнить',
      v => (v || '').length >= 6 || 'Пароль должен содержать минимум 6 символов'
    ],
    password2: '',
    password2Rules: [
      v => !!v || 'Необходимо заполнить'
    ],
    init: false
  }),
  computed: {
    rules () {
      const rules = []
      if (this.password) {
        const rule =
          v => (!!v && v) === this.password || 'Пароли не совпадают'
        rules.push(rule)
      }
      return rules
    }
  },
  watch: {
    // chip: function (val) {
    //   if (val === false) {
    //     this.disconnectFB()
    //   }
    // },
    // phoneCode: function (val) {
    //   if (val === '+375') {
    //     this.mask = '(##) ###-##-##'
    //   } else if (val === '+7') {
    //     this.mask = '(###) ###-##-##'
    //   }
    // }
  },
  created () {
    this.$store.commit('showNavigation')
    this.getInfo()
  },

  methods: {
    getInfo: function () {
      axios.get('/api/accountPage/getInfo')
        .then(response => {
          if (response.data.error) {
            this.errorMessage = response.data.message
            if (this.errorMessage !== 'unknown') {
              this.$router.push('/assist')
            }
          } else {
            this.populateData(response.data)
          }
          this.init = true
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    },
    changePassword: function () {
      if (this.$refs.password.validate()) {
        axios.post('/api/accountPage/changePassword', { password: this.password })
          .then(response => {
            this.$store.dispatch('showSnackbar', {
              text: 'Пароль обновлен',
              color: 'success'
            })
          })
          .catch(error => {
            this.$store.dispatch('handleError', error.response)
          })
      }
    },
    updateAccount: function () {
      this.accountInfo.user.defaultCompanyId = this.selectedCompany.yId
      let mobile
      if (this.phoneCode === '+375') {
        mobile = '375' + this.accountInfo.user.mobile// .substring(0, 9)
      } else if (this.phoneCode === '+7') {
        mobile = '7' + this.accountInfo.user.mobile// .substring(0, 10)
      }
      axios.post('/api/accountPage/update', {
        mobile: mobile,
        defaultCompanyId: this.accountInfo.user.defaultCompanyId
      })
        .then(response => {
          this.$store.dispatch('showSnackbar', {
            text: 'Настройки обновлены',
            color: 'success'
          })
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    },
    // connectFB: function () {
    //   window.FB.login(resLogin => {
    //     if (resLogin.status === 'connected') {
    //       window.FB.api('/me?fields=id, name', resMe => {
    //         axios.post('/api/accountPage/connectFB', resMe)
    //           .then(response => {
    //             if (response.data.error) {
    //               this.showError(response.data.message)
    //               window.FB.logout()
    //             } else {
    //               this.populateData(response.data)
    //             }
    //           })
    //           .catch(() => {
    //             this.showError('Во время подключения к Facebook произошла ошибка')
    //           })
    //       })
    //     } else {
    //       this.showError('Не удалось подключиться к Facebook')
    //     }
    //   })
    // },
    // disconnectFB: function () {
    //   axios.post('/api/accountPage/disconnectFB')
    //     .then(response => {
    //       if (response.data.error) {
    //         this.showError(response.data.message)
    //       } else {
    //         window.FB.getLoginStatus(resStatus => {
    //           if (resStatus.status === 'connected') {
    //             window.FB.logout()
    //             this.populateData(response.data)
    //           } else {
    //             this.populateData(response.data)
    //           }
    //         })
    //       }
    //     })
    //     .catch(() => {
    //       this.showError('Во время подключения к Facebook произошла ошибка')
    //     })
    // },
    showError: function (message) {
      this.$store.dispatch('showSnackbar', {
        text: message,
        color: 'error'
      })
    },
    populateData: function (data) {
      this.accountInfo = data
      if (this.accountInfo.user.defaultCompanyId !== -1 && this.accountInfo.user.defaultCompanyId !== undefined) {
        for (let i = 0; i < this.accountInfo.salons; i++) {
          if (this.accountInfo.salons[i].yId === this.accountInfo.user.defaultCompanyId) {
            this.selectedCompany = this.accountInfo.salons[i].yId
            break
          }
        }
      }
      if (this.selectedCompany === '') {
        this.selectedCompany = this.accountInfo.salons[0]
      }
      if (this.accountInfo.user.mobile !== '' && this.accountInfo.user.mobile !== undefined) {
        if (this.accountInfo.user.mobile.startsWith('375')) {
          this.phoneCode = '+375'
          this.accountInfo.user.mobile = this.accountInfo.user.mobile.substring(3, this.accountInfo.user.mobile.length)
        } else if (this.accountInfo.user.mobile.startsWith('7')) {
          this.phoneCode = '+7'
          this.accountInfo.user.mobile = this.accountInfo.user.mobile.substring(1, this.accountInfo.user.mobile.length)
        } else {
          this.phoneCode = '+375'
        }
      }
      // if (this.account.facebookId !== undefined && this.account.facebookId !== '' && this.account.facebookId !== null) {
      //   this.hasFBAccount = true
      //   this.chip = true
      // } else {
      //   this.hasFBAccount = false
      // }
    }
  }
}
</script>
